<div class="position-relative">
  <p-accordion [multiple]="true">
    <p-accordionTab [selected]="isDefaultOpen" [disabled]="!isCloseable">
      <p-header>
        <!-- <div class="pinned-notes-container appointment-notes clicked-tooltip clicked-tooltip-right send"
          *ngIf="isMarketingOptOutEnabled && followUp.unsubscribeCount === followUp?.contacts?.length">
          <app-content-overlay arrowTop="-5px" arrowRight="10px" right="-50px" [showArrow]="true" [showOnClick]="false"
            [showOnHover]="true">
            <ng-template appTemplate="item">
              <h2 class="mb-0 font-14">
                <i class="fal fa-alarm-clock inner-accordian-icon"></i>
                <span class="inner-accordian-text">
                  {{ followUp?.campaignTitle }}
                </span>

                <div class="action-box trash-field">
                  <span class="inner-accordian-delete" *ngIf="isScheduled">
                    <i *ngIf="!isScheduling" class="fal fa-trash-alt" tooltipPosition="top"
                      [pTooltip]="followUp?.deleteTooltip" (click)="handleDeleteFollowUp(followUp, $event)"></i>
                    <i *ngIf="isScheduling" class="fal fa-spinner rotate"></i>
                  </span>

                  <span class="inner-accordian-delete" *ngIf="!isScheduled">
                    <i *ngIf="!isScheduling" class="font-primary fal" pTooltip="Schedule" tooltipPosition="top"
                      [ngClass]="{ 'fa-plus': !isSchedulingCompleted, 'fa-check': isSchedulingCompleted }"
                      (click)="handleScheduleCampaign(followUp)"></i>
                    <i *ngIf="isScheduling" class="fal fa-spinner rotate"></i>
                  </span>
                </div>
              </h2>
            </ng-template>

            <ng-template appTemplate="overlay" let-close="close">
              <div
                class="ui-tooltip ui-widget ui-tooltip-left ticket-tooltip estimate modifier completed marketing-tooltip"
                style="display: inline-block; max-width: 245px; opacity: 1.036; position: static;">
                <div class="ui-tooltip-arrow"></div>
                <div class="ui-tooltip-text ui-shadow ui-corner-all">
                  <div class="tooltip-seondary">
                    <div class="tooltip-secondary-row font-14 font-bold font-secondary-800 pb-1">
                      <i class="fal fa-exclamation-triangle font-orange"></i>
                      Reset preference?
                    </div>

                    <div class="tooltip-secondary-row font-12 font-secondary-900 py-0 d-flex flex-nowrap">
                      <span class="pl-25">Resubscribe contact to marketing campaigns. </span>
                    </div>
                    <div class="tooltip-secondary-row font-12 font-orange py-0 mt-2 d-flex justify-content-end pb-1">
                      <button class="btn btn-primary btn-small font-bold marketing-btn" [disabled]="isResetLoading"
                        (click)="resetPreference($event,close)">
                        Yes
                        <i *ngIf="isResetLoading" class="fal fa-spinner rotate ml-2"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
          </app-content-overlay>
        </div> -->

        <h2 class="mb-0 font-14">
          <i *ngIf="isMarketingOptOutEnabled && followUp.unsubscribeCount"
            class="fal fa-exclamation-triangle inner-accordian-icon pt-2px flex-self-start font-yellow"></i>

          <i *ngIf="(!isMarketingOptOutEnabled || !followUp.unsubscribeCount)"
            [ngClass]="[hasCampaingStatusStopped && isAutomatedFollowUpEnabled ? 'fal fa-times-circle text-red' : 'fal fa-alarm-clock']"
            [pTooltip]="followUp.stopTooltip || ''" class="inner-accordian-icon pt-2px flex-self-start"></i>

          <!--
            <i *ngIf="!isMarketingOptOutEnabled || !followUp.unsubscribeCount"
            class="fal fa-alarm-clock inner-accordian-icon pt-2px flex-self-start"></i> -->
          <span class="inner-accordian-text text-break">
            {{ followUp?.campaignTitle }}
          </span>

          <div *ngIf="checkFollowUpDate" style="margin-left: 10px;" class="square mr-2 flex-start-center">
            <span class="padding-new font-primary pointer font-11">New</span>
          </div>

          <div class="action-box trash-field">

            <span class="inner-accordian-delete" *ngIf="isScheduled && !isAutomatedFollowUpEnabled">
              <i *ngIf="!isScheduling" class="fal fa-trash-alt" tooltipPosition="top"
                [pTooltip]="followUp?.deleteTooltip" (click)="handleDeleteFollowUp(followUp, $event)"></i>

              <i *ngIf="isScheduling" class="fal fa-spinner rotate"></i>
            </span>

            <span class="inner-accordian-delete mt-5px"
              *ngIf="isScheduled && !hasCampaingStatusStopped && isAutomatedFollowUpEnabled">
              <i *ngIf="!isScheduling" class="fal fa-times-circle text-red" tooltipPosition="top"
                [pTooltip]="followUp?.deleteTooltip" (click)="handleUpdateStatus(followUp)"></i>

              <i *ngIf="isScheduling" class="fal fa-spinner rotate"></i>
            </span>



            <span class="inner-accordian-delete" *ngIf="!isScheduled">
              <span *ngIf="!isScheduling">
                <i *ngIf="!isMarketingOptOutEnabled || followUp.unsubscribeCount !== followUp?.contacts?.length"
                  class="font-primary fal" pTooltip="Schedule" tooltipPosition="top"
                  [ngClass]="{ 'fa-plus': !isSchedulingCompleted, 'fa-check': isSchedulingCompleted }"
                  (click)="handleScheduleCampaign(followUp)"></i>
              </span>

              <i *ngIf="isScheduling" class="fal fa-spinner rotate"></i>

              <div class="pinned-notes-container appointment-notes clicked-tooltip clicked-tooltip-right"
                *ngIf="isMarketingOptOutEnabled && followUp.unsubscribeCount === followUp?.contacts?.length">
                <app-content-overlay arrowTop="-5px" arrowRight="10px" right="-50px" [showArrow]="true"
                  [showOnClick]="true" [showOnHover]="false" [stopPropagation]="true">
                  <ng-template appTemplate="item">
                    <i class="fal fa-plus text-primary" *ngIf="!isScheduling"></i>
                  </ng-template>

                  <ng-template appTemplate="overlay" let-close="close">
                    <div
                      class="ui-tooltip ui-widget ui-tooltip-left ticket-tooltip estimate modifier completed marketing-tooltip"
                      style="display: inline-block; max-width: 245px; opacity: 1.036; position: static;">
                      <div class="ui-tooltip-arrow"></div>
                      <div class="ui-tooltip-text ui-shadow ui-corner-all">
                        <div class="tooltip-seondary">
                          <div class="tooltip-secondary-row font-14 font-bold font-secondary-800 pb-1">
                            <i class="fal fa-exclamation-triangle font-orange"></i>
                            Reset preference?
                          </div>

                          <div class="tooltip-secondary-row font-12 font-secondary-900 py-0 d-flex flex-nowrap">
                            <span class="pl-25">Resubscribe contact to marketing campaigns. </span>
                          </div>
                          <div
                            class="tooltip-secondary-row font-12 font-orange py-0 mt-2 d-flex justify-content-end pb-1">
                            <button class="btn btn-primary btn-small font-bold marketing-btn"
                              [disabled]="isResetLoading" (click)="resetPreference($event, close)">
                              Yes
                              <i *ngIf="isResetLoading" class="fal fa-spinner rotate ml-2"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                </app-content-overlay>
              </div>
            </span>
          </div>
        </h2>
      </p-header>

      <div class="inner-accordian-content">
        <!-- Follow-up top -->
        <div class="accordian-inner-row">
          <!-- Schedule date -->
          <div class="datetime-overlay-follow-up date-section accordian-inner-col overflow-normal">
            <i class="fal fa-calendar-alt inner-col-icon"></i>
            <app-content-overlay *ngIf="!followUp?.isSend" right="auto" top="26px" arrowTop="-10px" arrowRight="19%"
              [closeOnClickOutside]="false" [showArrow]="true">
              <ng-template appTemplate="item">
                <span class="date-section inner-data pointer hover-underline">
                  {{ followUp?.scheduleAt | date: 'MMM d, yyyy hh:mma' }}
                </span>
              </ng-template>

              <ng-template appTemplate="overlay" let-close="close">
                <div class="invoice-date-change-overlay">
                  <div class="invoice-date-content flex-start-center">
                    <div
                      class="flex-start-center calender-setting-1 font-12 invoice-date-calendar-input date-picker mr-2 pointer">
                      <p-calendar id="start-date" dateFormat="M dd, yy" inputStyleClass="pointer" [readonlyInput]="true"
                        [(ngModel)]="scheduleAt.date" [minDate]="currentTime" (onSelect)="scheduleAt.date = $event"
                        #invoiceDateCalendar>
                      </p-calendar>
                      <i class="fal fa-calendar font-gray-75 invoice-date-icon"
                        (click)="invoiceDateCalendar.showOverlay()"></i>
                    </div>

                    <div class="time-dropdown">
                      <kendo-timepicker [min]="currentTime" [(value)]="scheduleAt.time"
                        [formatPlaceholder]="{ hour: 'hh', minute: 'mm' }"> </kendo-timepicker>
                    </div>
                  </div>
                  <div class="invoice-date-footer flex-end-center mt-1 pt-2 pr-2 pl-2">
                    <span class="btn btn-white btn-50 font-12 text-center mr-1 pointer" (click)="close()">Cancel</span>
                    <span class="btn btn-primary btn-50 font-12 text-center pointer"
                      (click)="handleUpdateScheduleAt(followUp?.followUpId, close)">Save</span>
                  </div>
                </div>
              </ng-template>
            </app-content-overlay>

            <span *ngIf="followUp?.isSend" class="date-section inner-data pointer">
              {{ followUp?.scheduleAt | date: 'MMM d, yyyy hh:mma' }}
            </span>
          </div>

          <!-- Vehicle -->
          <div class="accordian-inner-col">
            <i class="fal fa-car inner-col-icon"></i>
            <span class="inner-data text-truncate">
              {{ followUp?.vehicle?.name }}
            </span>
          </div>
        </div>

        <!-- Follow-up bottom -->
        <div class="accordian-inner-row">
          <!-- Contact -->
          <div *ngIf="followUp?.type === 'EMAIL'" class="accordian-inner-col hover-underline pointer">
            <i class="fal fa-envelope inner-col-icon mt-2p"></i>

            <div tooltipStyleClass="ticket-tooltip modifier ticket-size completed marketing-tooltip width-extend"
              [escape]="false" [pTooltip]="followUp?.contactTooltip" (click)="handleOpenContactDialog()">
              <span class="inner-data text-truncate" *ngIf="followUp?.contacts?.length > 1"> {{
                followUp?.contacts?.length }} email addresses </span>

              <span class="inner-data text-truncate" *ngIf="followUp?.contacts?.length === 1">
                {{ (followUp?.contacts)[0] || '' }}
              </span>
            </div>
          </div>

          <div *ngIf="followUp?.type === 'SMS'" class="accordian-inner-col hover-underline pointer">
            <i class="fal fa-envelope inner-col-icon"></i>

            <div tooltipStyleClass="ticket-tooltip modifier ticket-size completed marketing-tooltip" [escape]="false"
              [pTooltip]="followUp?.contactTooltip" (click)="handleOpenContactDialog()">
              <span class="inner-data text-truncate" *ngIf="followUp?.contacts?.length > 1"> {{
                followUp?.contacts?.length }} phones </span>

              <span class="inner-data text-truncate" *ngIf="followUp?.contacts?.length === 1">
                {{ (followUp?.contacts && (followUp?.contacts)[0]) || '' | mask: '(000) 000-0000' }}
              </span>
            </div>
          </div>

          <!-- Template -->
          <div class="accordian-inner-col">
            <i class="fal fa-align-justify inner-col-icon"></i>
            <span class="inner-data text-truncate pointer hover-underline"
              (click)="handleOpenTemplate(followUp?.marketingTemplate)">
              {{ followUp?.marketingTemplate?.text }}
            </span>
          </div>
        </div>
      </div>

      <div *ngIf="isScheduled && hasCampaingStatusStopped && isAutomatedFollowUpEnabled"
        (click)="hasCampaingStatusStopped ? handleUpdateStatus(followUp) : ''" class="resume-followup">
        <span class="pl-5">
          <i class="fal fa-play pl-5"></i>
          Resume follow-up
        </span>
      </div>
    </p-accordionTab>
  </p-accordion>
</div>
